import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import web3 from "web3";
// import ReCAPTCHA from "react-google-recaptcha";

import BuyGeosModal from "./components/buyGeosModal";
import DownloadsModal from "./components/downloadsModal";
import ErrorModal from "./components/errorModal";
import Footer from "./components/footer";
import Header from "./components/header";
// import InfoModal from "./components/infoModal";
import Layout from "./components/layout";
// import SpinCount from "./components/spinCount";
import WalletSelector from "./components/walletSelector";
import Wheel from "./components/wheel";

// import fieldTypes from "./models/fieldTypes";

import { W3Context } from "./services/context";
import { FARMING_CONTRACT, GEOS_CONTRACT } from "./services/contract";

// import infoImage from "./assets/info_icon.png";
import wheelIconImage from "./assets/wheel_icon.png";

import { toFormattedGeoTokensAmount } from "./utils/amount";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// const { REACT_APP_POLYGONSCAN_API_KEY_TOKEN, REACT_APP_SITE_KEY_CAPTCHA } =
// process.env;

// const GAS_FEE = "36";
const DEFAULT_ERROR_MESSAGE = "An unexpected error has occurred";

// const arrayElements = [
//   {
//     type: fieldTypes.GEOS,
//     label: "50 GEO$",
//     amount: 50,
//     probability: 18.5419,
//     position: 1,
//     rewardPackageId: 0,
//   },
//   {
//     type: fieldTypes.GEOS,
//     label: "5000 GEO$",
//     amount: 5000,
//     probability: 2.225,
//     position: 2,
//     rewardPackageId: 4,
//   },
//   {
//     type: fieldTypes.SPECIAL_LOCATION,
//     label: "Special Location",
//     probability: 0.0445,
//     position: 3,
//     rewardPackageId: 9,
//   },
//   {
//     type: fieldTypes.GEOS,
//     label: "1000 GEO$",
//     amount: 1000,
//     probability: 11.1251,
//     position: 4,
//     rewardPackageId: 3,
//   },
//   {
//     type: fieldTypes.LOCATION,
//     label: "Premium NFT",
//     tier: 3,
//     probability: 0.0668,
//     position: 5,
//     rewardPackageId: 8,
//   },
//   {
//     type: fieldTypes.GEOS,
//     label: "500 GEO$",
//     amount: 500,
//     probability: 22.2502,
//     position: 6,
//     rewardPackageId: 2,
//   },
//   {
//     type: fieldTypes.LOCATION,
//     label: "Standard NFT",
//     tier: 2,
//     probability: 0.1335,
//     position: 7,
//     rewardPackageId: 7,
//   },
//   {
//     type: fieldTypes.GEOS,
//     label: "250 GEO$",
//     amount: 250,
//     probability: 44.5004,
//     position: 8,
//     rewardPackageId: 1,
//   },
//   {
//     type: fieldTypes.LOCATION,
//     label: "Basic NFT",
//     tier: 1,
//     probability: 0.5563,
//     position: 9,
//     rewardPackageId: 6,
//   },
//   {
//     type: fieldTypes.GEOS,
//     label: "20000 GEO$",
//     amount: 20000,
//     probability: 0.5563,
//     position: 10,
//     rewardPackageId: 5,
//   },
// ];

const App = () => {
  const { active, account, library } = useContext(W3Context);
  const [isCalled, setIsCalled] = useState(false);

  // const [elements, setElements] = useState(arrayElements);

  // const [displayInfoModal, setDisplayInfoModal] = useState(false);
  // const [shouldRefresh, setShouldRefresh] = useState(false);

  // const [geoSpinsAmount, setGeoSpinsAmount] = useState(0);
  // const [availableGeosAmount, setAvailableGeosAmount] = useState(0);
  // const [
  //   allowedGeosAmountFromGeoTokenContract,
  //   setAllowedGeosAmountFromGeoTokenContract,
  // ] = useState(0);
  // const [isApproving, setIsApproving] = useState(false);
  // const [isBuying, setIsBuying] = useState(false);
  // const [spinsQuantityToBuy, setSpinsQuantityToBuy] = useState(0);

  const [displayConnectWalletModal, setDisplayConnectWalletModal] =
    useState(false);

  // const captcha = useRef(null);
  // const [captchaValidated, setCaptchaValidated] = useState(false);

  const [geoTokensAmountHeader, setGeoTokensAmountHeader] = useState("-");
  const [NFTsAmount, setNFTsAmount] = useState("-");
  // const [geoSpinsAmountHeader, setGeoSpinsAmountHeader] = useState("-");

  const [displayBuyGEOTokens, setDisplayBuyGEOTokens] = useState(false);
  const [displayDownloads, setDisplayDownloads] = useState(false);

  const [errorMessage, setErrorMessage] = useState(DEFAULT_ERROR_MESSAGE);
  const [displayErrorModal, setDisplayErrorModal] = useState(false);

  // const [isSettedGasFee, setIsSettedGasFee] = useState(false);
  // const [gasFee, setSuggestedGasFee] = useState(GAS_FEE);

  // const getGeoSpinsAmount = async () => {
  //   console.log("Getting GeoSpins amount...");

  //   if (active) {
  //     const contract = new library.eth.Contract(
  //       FARMING_CONTRACT.abi,
  //       FARMING_CONTRACT.address
  //     );
  //     const myAddress = library.utils.toChecksumAddress(account);

  //     try {
  //       const amount = await contract.methods.spinBalance(myAddress).call();
  //       setGeoSpinsAmount(amount);
  //       setGeoSpinsAmountHeader(amount);

  //       setIsCalled(true);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // };

  const getAvailableGeosAmount = async () => {
    console.log("Getting available GEOs amount...");

    if (active) {
      const contract = new library.eth.Contract(
        GEOS_CONTRACT.abi,
        GEOS_CONTRACT.address
      );

      try {
        await contract.methods
          .balanceOf(web3.utils.toChecksumAddress(account))
          .call()
          .then((res) => {
            const amount = web3.utils.fromWei(res, "ether");
            // setAvailableGeosAmount(parseFloat(amount).toFixed(2));
            setGeoTokensAmountHeader(toFormattedGeoTokensAmount(amount));
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  // const getAllowedGeosAmountFromGeoTokenContract = async () => {
  //   console.log("Getting allowed GEOs amount from GeoToken Contract...");

  //   if (active) {
  //     const contract = new library.eth.Contract(
  //       GEOS_CONTRACT.abi,
  //       GEOS_CONTRACT.address
  //     );

  //     try {
  //       await contract.methods
  //         .allowance(
  //           web3.utils.toChecksumAddress(account),
  //           FARMING_CONTRACT.address
  //         )
  //         .call()
  //         .then((res) => {
  //           setAllowedGeosAmountFromGeoTokenContract(res);
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         });
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // };

  const getNFTsAmount = async () => {
    console.log("Getting NFT amount...");

    if (active) {
      const contract = new library.eth.Contract(
        FARMING_CONTRACT.abi,
        FARMING_CONTRACT.address
      );

      try {
        const NFTs = await contract.methods
          .getWalletNFTs(library.utils.toChecksumAddress(account))
          .call();
        setNFTsAmount(NFTs.length);
      } catch (err) {
        console.log(err);
      }
    }
  };

  // const getSuggestedGasFee = async () => {
  //   console.log("Getting suggested gas fee...", isSettedGasFee);

  //   if (!isSettedGasFee) {
  //     try {
  //       const response = await fetch(
  //         `https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=${REACT_APP_POLYGONSCAN_API_KEY_TOKEN}`
  //       );
  //       const { result } = await response.json();
  //       const { FastGasPrice } = result;
  //       setSuggestedGasFee(FastGasPrice);

  //       setIsSettedGasFee(true);
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   }
  // };

  const refreshData = () => {
    setTimeout(() => {
      // getGeoSpinsAmount();
      getNFTsAmount();
      getAvailableGeosAmount();
      // getAllowedGeosAmountFromGeoTokenContract();
    }, 500);
  };

  useEffect(() => {
    if (!isCalled) {
      refreshData();
    }
  }, [active, isCalled]);

  // useEffect(() => {
  //   refreshData();
  // }, [shouldRefresh]);

  // useEffect(() => {
  //   getSuggestedGasFee();
  // }, []);

  // const onCaptchaChange = () => {
  //   const value = captcha.current.getValue() ? true : false;
  //   setCaptchaValidated(value);
  // };

  return (
    <>
      <WalletSelector
        displayModal={displayConnectWalletModal}
        setDisplayModal={setDisplayConnectWalletModal}
      />
      {/* <InfoModal
        elements={elements}
        displayModal={displayInfoModal}
        setDisplayModal={setDisplayInfoModal}
      /> */}
      <BuyGeosModal
        displayModal={displayBuyGEOTokens}
        setDisplayModal={setDisplayBuyGEOTokens}
      />
      <DownloadsModal
        displayModal={displayDownloads}
        setDisplayModal={setDisplayDownloads}
      />
      <ErrorModal
        message={errorMessage}
        displayModal={displayErrorModal}
        setDisplayModal={setDisplayErrorModal}
      />
      <Header
        geoTokensAmount={geoTokensAmountHeader}
        NFTsAmount={NFTsAmount}
        // geoSpinsAmount={geoSpinsAmountHeader}
        setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
        setDisplayDownloads={setDisplayDownloads}
        onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
      />
      <Layout>
        <Container className="viewer">
          <Row className="align-items-center">
            <Col xs={12} md={5} lg={6} className="spin-viewer">
              <Row className="justify-content-center mb-3">
                <img src={wheelIconImage} alt="wheel-icon" />
              </Row>
              <Row className="justify-content-center title-container">
                <span> NEW WHEEL OF FORTUNE</span>
              </Row>
              <Row className="justify-content-center subtitle-container mb-3">
                <span>Coming soon</span>
              </Row>
              {/* <Row className="justify-content-center mb-5">
                {active ? (
                  <SpinCount
                    amount={geoSpinsAmount}
                    isLoading={!isCalled}
                    availableGeosAmount={availableGeosAmount}
                    allowedGeosAmountFromGeoTokenContract={
                      allowedGeosAmountFromGeoTokenContract
                    }
                    setAllowedGeosAmountFromGeoTokenContract={
                      setAllowedGeosAmountFromGeoTokenContract
                    }
                    isApproving={isApproving}
                    setIsApproving={setIsApproving}
                    isBuying={isBuying}
                    setIsBuying={setIsBuying}
                    spinsQuantityToBuy={spinsQuantityToBuy}
                    setSpinsQuantityToBuy={setSpinsQuantityToBuy}
                    setShouldRefresh={setShouldRefresh}
                    setErrorMessage={setErrorMessage}
                    setDisplayErrorModal={setDisplayErrorModal}
                    GAS_FEE={gasFee}
                  />
                ) : (
                  <div>
                    <ReCAPTCHA
                      ref={captcha}
                      sitekey={REACT_APP_SITE_KEY_CAPTCHA}
                      onChange={onCaptchaChange}
                    />
                    <div className="text-center mt-3">
                      <button
                        className="connect-wallet-button mx-auto"
                        onClick={() => setDisplayConnectWalletModal(true)}
                        disabled={!captchaValidated}
                      >
                        Connect Wallet
                      </button>
                    </div>
                  </div>
                )}
              </Row> */}
            </Col>
            <Col xs={12} md={7} lg={6}>
              {/* <Row className="info-button-row justify-content-end ">
                <button
                  className="info-button"
                  onClick={() => setDisplayInfoModal(true)}
                >
                  <img src={infoImage} alt="info-icon" />
                </button>
              </Row> */}
              <Row className="justify-content-center">
                <Wheel
                // elements={elements}
                // geoSpinsAmount={geoSpinsAmount}
                // setGeoSpinsAmount={setGeoSpinsAmount}
                // setShouldRefresh={setShouldRefresh}
                // setErrorMessage={setErrorMessage}
                // displayErrorModal={displayErrorModal}
                // setDisplayErrorModal={setDisplayErrorModal}
                // DEFAULT_ERROR_MESSAGE={DEFAULT_ERROR_MESSAGE}
                // GAS_FEE={gasFee}
                />
              </Row>
            </Col>
          </Row>
        </Container>
      </Layout>
      <Footer />
    </>
  );
};

export default App;
